import { z } from 'zod';

export const WayfinderJson = z.object({
  tid: z.string().optional(),
  term: z.string().optional(),
  parent_target_id: z.string().optional(),
  field_choose_destination_url: z.string().optional(),
  field_destination_url: z.string().optional(),
});

export type WayfinderJson = z.infer<typeof WayfinderJson>;
